<template>
    <div class="body" part="wb-body" ref="body">
        <div v-if="loading">
            <v-skeleton-loader
                    type="card-avatar"
                    height="102"
            ></v-skeleton-loader>
        </div>
        <div v-else class="tile-box" part="wb-tile-box" v-bind:style="{backgroundColor: backgroundColor ,color: color, borderColor: borderColor}">
            <div class="tile-header" part="wb-tile-header">
                {{title}}
            </div>
            <div class="tile-content-wrapper" part="wb-tile-content-wrapper">
                <div v-if="loading" class="w-100 d-flex justify-content-center" part="wb-justify-content-center">
                    <span class="loading"></span>
                </div>
                <i v-if="!loading" class="glyph-icon" v-bind:class="iconMoney"></i>
                <div v-if="!loading" class="tile-content" part="wb-tile-content-wrapper">
                    {{typeof balance === 'number'? wMM((Math.round(balance*100)).toString()).slice(0,-2) : '0.'}}<small class="small">{{typeof balance === 'number'? wMM((Math.round(balance*100)).toString()).slice(-2) : '00'}}</small>
                </div>
            </div>
        </div>
      <div v-html="innerHtmlCode"></div>
    </div>
</template>
<script>
    import {VSkeletonLoader} from 'vuetify/lib'
    import Layer0 from '../../extend_classes/Layer0'
    const i18n = new window.VueI18n({
        locale: 'en-US', // set locale
        fallbackLocale: 'en-US',
        messages: {
            "en-US": {
            "message": {
                "metrics": "Metrics"
            }
            }
        }
    });
    export default {
        name: 'wallet-balance',
        i18n: i18n,
        extends: Layer0,
        components: {
            VSkeletonLoader,  
        },
        data: function () {
            return {
                wMM: a => a,
                loading: false,
                aid: null,
                balance: 0,
                wc: [],
                title: 'Loading...'
            }
        },
        props: {
            accountId: {
                type: Number,
                required: false
            },
            iconMoney: {
                type: String,
                required: false,
                default: 'icon-dollar'
            },
            backgroundColor: {
                type: String,
                required: false,
                default: '#3498db'
            },
            borderColor: {
                type: String,
                required: false,
                default: '#308dcc'
            },
            walletCountries: {
                type: String,
                required: false,
                default: '[]'
            },
            color: {
                type: String,
                required: false,
                default: '#fff'
            },
            walletId: {
                type: Number,
                required: true
            },
            innerHtmlCode: {
              required: false,
              type: String
            },
            ...Layer0.props
        },
        methods: {
            getAp() {
                this.wMM = window.MLMSoftUICore.wearMaskMoney;

                let wc;
                try {
                    wc = JSON.parse(this.walletCountries);
                    if (!Array.isArray(wc))
                        wc = [];
                }
                catch (e) {
                    wc = [];
                }
                if (wc.length)
                    this.wc = wc;
            },
            async getInfo() {
                this.getAp();
                this.loading = true;

                try {
                    await this.store.dispatch('getLocalizationModule', {module: 'Api2Middleware', i18n, customLocalization: '/user/themes/monarch/images/localization_core/core.txt', UIProxyLoc: JSON.parse(JSON.stringify(i18n._vm.messages))});
                } catch (error) {
                    console.log('-------------------------------')
                    console.log('error', error)
                }
                
                this.aid = this.accountId;
                if (!this.aid)
                    this.aid = await this.store.dispatch('getAccountId');
                let walletBalancePromise = this.getWalletsBalance();

                await walletBalancePromise.then(res => {
                    let wb = null;

                    try {
                        let delay = 0;
                        if (!this.store.state.currentProfile) {
                            delay = 2000
                        }

                        setTimeout(() => {
                            if (this.wc && this.wc?.length) {
                                let found = this.store.state.currentProfile.find((f) => f.alias == 'country_id')

                                this.wc.forEach((country) => {
                                    if (found && found?.value?.raw.toLowerCase() == country[0].toLowerCase()) {
                                        this.walletId = country[1];
                                    }
                                })
                            }

                            if (res.data.payload.length != 0) {
                                wb = res.data.payload.find(wal => {
                                    return wal.id === Number(this.walletId)
                                })
                            }

                            if (wb) {
                                let loc = i18n.t('message.' + wb.alias)
                                this.title = (loc && loc != 'message.' + wb.alias ? loc : wb.title)
                                wb = Number.parseFloat(wb.balance);
                            } else {
                                this.balance = 0;
                            }

                            this.balance = wb || 0;
                            this.loading = false;
                        }, delay)
                        
                    } catch (error) {
                        console.log('---------------WalletBalance error----------------', error)
                    }

                }).catch(() => {
                    this.loading = false;
                });
            },
            async getWalletsBalance() {
                return await this.store.dispatch('requestApi3', {
                    path: `account/${this.aid}/wallet`,
                    method: 'get'
                })
            }
        }
    }
</script>
<style scoped>
    @import '~vuetify/dist/vuetify.min.css';
    @import './../../styles/projectStyles/vuetify/vuetify-del.css';
    @import '~bootstrap/dist/css/bootstrap.min.css';
    @import "./../../styles/monarch/themes/admin/color-schemes/default.css";
    @import "./../../styles/monarch/helpers/colors.css";
    @import "./../../styles/monarch/helpers/boilerplate.css";
    @import "./../../styles/monarch/helpers/border-radius.css";
    @import "./../../styles/monarch/themes/components/border-radius.css";
    @import "./../../styles/monarch/elements/tile-box.css";
    @import "./../../styles/monarch/themes/components/default.css";
    @import "./../../styles/monarch/helpers/utils.css";
    @import "./../../styles/monarch/helpers/typography.css";
    @import "./../../styles/monarch/icons/fontawesome/fontawesome.css";
    @import "./assets/wallet-balance.css";
</style>
